// extracted by mini-css-extract-plugin
export var footer = "_lw-5";
export var fulfillmentInput = "_lw-0";
export var shipDateInput = "_lw-1";
export var shipmentModal = "_lw-2";
export var shipmentModalContent = "_lw-3";
export var tableContainer = "_lw-4";